// GLOBAL
export const INVOICE_MODE = {
  lite: 'LITE',
  full: 'FULL',
}

export const INVOICE_V2 = '2025-11-24'

export const DPP_AMOUNT_TYPE = ['AMOUNT', 'PERCENTAGE']

export const MAX_INVOICE = 50000000000
export const MAX_COMPANY_INFORMATION_LENGTH = 500
export const MAX_STORE_DESCRIPTION_LENGTH = 500
export const MIN_STORE_ADDRESS_LENGTH = 20
export const MAX_STORE_ADDRESS_LENGTH = 200
export const MAX_PRODUCT_NAME_LENGTH = 70
export const MAX_PRODUCT_PRICE = 50000000000
export const MAX_PRODUCT_QUANTITY = 10000000
export const MAX_STRING_LENGTH = 50
export const MAX_TOTAL_AMOUNT = 50000000000
export const MAX_TAX_DPP_AMOUNT = 50000000000
export const MAX_TAX_PPN_AMOUNT = 50000000000
export const MAX_TAX_PPH_AMOUNT = 50000000000
export const INVOICE_TAX_DPP_RATE = 1.1 // PPN 11%
export const INVOICE_TAX_PPH_RATE = 0.02 // PPh 2%
export const MAX_INVOICE_TOTAL_AMOUNT_TOLERANCE = 0
export const TIMEOUT_DURATION_CHECKEMAIL_RFQ = 20000
export const TIMEOUT_DURATION_UPLOAD_IMAGE = 20000
export const MAX_INSURANCE_FEE = 5000000
export const MAX_SHIPPING_FEE = 5000000
export const MAX_NUMBER_INTEGER = 500000000000000000
export const MIN_NUMBER_INTEGER = -9000000000000000
export const MONTH_NAMES = {
  1: {
    abv: 'jan',
    full: 'january',
  },
  2: {
    abv: 'feb',
    full: 'february',
  },
  3: {
    abv: 'mar',
    full: 'march',
  },
  4: {
    abv: 'apr',
    full: 'april',
  },
  5: {
    abv: 'may',
    full: 'may',
  },
  6: {
    abv: 'jun',
    full: 'june',
  },
  7: {
    abv: 'jul',
    full: 'july',
  },
  8: {
    abv: 'aug',
    full: 'august',
  },
  9: {
    abv: 'sep',
    full: 'september',
  },
  10: {
    abv: 'oct',
    full: 'october',
  },
  11: {
    abv: 'nov',
    full: 'november',
  },
  12: {
    abv: 'dec',
    full: 'december',
  },
}
export const WYSIWYG_TOOLBAR = {
  options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'embedded', 'image'],
  inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough'],
    bold: { className: undefined },
    italic: { className: undefined },
    underline: { className: undefined },
    strikethrough: { className: undefined },
  },
  blockType: {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  list: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered', 'indent', 'outdent'],
    unordered: { className: undefined },
    ordered: { className: undefined },
    indent: { className: undefined },
    outdent: { className: undefined },
  },
  textAlign: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['left', 'center', 'right', 'justify'],
    left: { className: undefined },
    center: { className: undefined },
    right: { className: undefined },
    justify: { className: undefined },
  },
  link: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    popupClassName: 'popup-right',
    dropdownClassName: undefined,
    showOpenOptionOnHover: true,
    defaultTargetOption: '_self',
    options: ['link', 'unlink'],
    link: { className: undefined },
    unlink: { className: undefined },
    linkCallback: undefined,
  },
  embedded: {
    className: undefined,
    component: undefined,
    popupClassName: 'popup-right',
    embedCallback: undefined,
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
  image: {
    className: undefined,
    component: undefined,
    popupClassName: 'popup-right',
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: true,
    uploadCallback: true,
    previewImage: true,
    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    alt: { present: true, mandatory: false },
    defaultSize: {
      height: 'auto',
      width: '300px',
    },
  },
  history: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['undo', 'redo'],
    undo: { className: undefined },
    redo: { className: undefined },
  },
}
export const DATE_API_FORMAT = 'YYYY-MM-DD 23:59:59'
export const DATE_API_FORMAT_ZERO = 'YYYY-MM-DD 00:00:00'
export const DATE_FILENAME_FORMAT = 'YYYYMMDDHHmmss'
export const DATETIME_API_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATETIME_DEFAULT_FORMAT = 'DD/MM/YYYY HH:mm'
export const DATETIME_FORMAT_WITHOUT_HOUR = 'DD/MM/YYYY'

// RFQ
export const RFQ_FINAL_STATUS = [
  'CANCELLED_BY_BUYER', //ga bisa chat
  'CANCELLED_BY_SELLER',
  'CANCELLED_BY_ORDER',
  'REJECTED_BY_SELLER', // ga bisa chat, ga bisa lihat
  'OFFER_BY_SELLER', // bisa chat, bisa lihat
  'APPROVED_BY_BUYER', // ga bisa chat, bisa lihat
  'REJECTED_BY_BUYER', // ga bisa chat
]
export const RFQ_UNFINAL_STATUS = ['REQUESTED_BY_BUYER']
export const RFQ_OFFER_STATUS = ['OFFER_BY_SELLER']
export const RFQ_CHATTABLE = ['OFFER_BY_SELLER', 'REQUESTED_BY_BUYER']
export const RFQ_PRODUCT_SEEN_COUNT = 2
export const RFQ_INSTALLMENT_GAP = 100
export const RFQ_INSTALLMENT_MINIMUM = 10000

export const TRANSACTION_PRODUCT_SEEN_COUNT = 2
export const TRANSACTION_INSTALLMENT_GAP = 100
export const TRANSACTION_INSTALLMENT_MINIMUM = 10000

// Order
export const ORDER_INITIAL_STATUS = [
  // 'WAITING_PAYMENT',
  'PROCESSED',
  'SHIPPED',
  'DELIVERED',
  'COMPLETED',
  'REFUND',
  'CANCELLED',
  'CLOSE_ORDER_REQUEST',
]
export const RETURN_INITIAL_STATUS = ['REQUEST', 'APPROVED', 'CANCELLED', 'REJECTED']
export const SHIPMENT_INITIAL_STATUS = ['SHIPPED', 'DELIVERED', 'CANCELLED', 'CORRECTION']
export const CORRECTION_INITIAL_STATUS = ['REQUEST', 'CANCELLED', 'APPROVED', 'REJECTED']

// Notification
export const NOTIFICATION_STATUS = ['RFQ', 'PAYMENT', 'INFO', 'ORDER']

// FUND
export const MIN_WITHDRAW_AMOUNT = 10000

// FILE TYPE
export const IMAGE_FILE_TYPE = ['jpg', 'png', 'jpeg']

export const PRODUCT_TYPE = ['GOODS', 'SERVICE']

export const PRODUCT_TAX = ['0', '11', '12']
